export default __webpack_public_path__ + "static/media/card1.85ca9442.svg";